module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "overtime_logo.40e41b9c.svg";